module.exports = __webpack_public_path__ + "client/img/company_logo.7fc69b86.png";